import React, { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { LSRW } from '../../utils/const';
import { tagEvent } from '../../utils/tagManager';
import {
	fetchAttempt,
	setShowTestInstr,
} from '../../redux/myCourse/myCourse.actions';
import {
	startAttempt,
	toggleMicPermission,
} from '../../redux/testPage/testPage.actions';
import Modal from 'react-bootstrap/Modal';
import { setSpeechStatus } from '../../redux/utilities/utils.actions';
import { recordAudio, sleep, isIos } from '../../utils/commonFunctions';
import UserTypes from '../../utils/userTypes';
import Config from '../../config/Config';
import Loader from '../../utils/Loader';
import { continuousVisualizer, currentVisualizer } from 'sound-visualizer';

const TestInstruction = React.memo(function TestInstruction({
	instrDetails,
	fetchAttempt,
	startAttempt,
	//courseId,
	toggleMicPermission,
	showTestInstr,
	setShowTestInstr,
	showReview,
	hideSpeakTest,
	userType,
	product_id,
	product_name,
	userId,
	course_name,
}) {

	const [showPlayerTag, setShowPlayerTag] = useState(false);
	const [activeInstrTab, setActiveInstrTab] = useState('step-1');
	const [agreeInstructions, setAgreeInstructions] = useState(false);
	const recordButtonRef = useRef(null);
	const stepOneNextButton = useRef(null);

	const {
		domain,
		domains,
		hideStart,
		attemptRemaning,
		elementId,
		elementType,
		continueAttemptId,
		unitName,
		courseId,
		totalQuestion,
		sumTimeLimit,
		elementName,
		reviewAttemptId,
		previewMode,
	} = instrDetails;

	// alert(continueAttemptId)

	const currentVisual = document.getElementById("currentVisual");

	const handleClickAction = (event) => {
		console.log('handleClickAction ', event)
		event.currentTarget.disabled = true;
		// Loader.show()
		event.stopPropagation()
	}

	var domainList = '';
	if (!!domain || !!domains) {
		domainList = domain.split('|').map(function (key) {
			return (
				<li key={key}>
					<img src={Config.ASSETSPATH + 'img/' + LSRW[key] + '.png'} alt="" />
				</li>
			);
		});
	}
	const [isSpeechAvail, setIsSpeechAvail] = useState(false);
	useEffect(() => {
		setIsSpeechAvail(false);
		domains.forEach((domain) => {
			let result = domain.replace(/^\s+|\s+$/gm, '');
			if (result === 'Speaking') {
				setIsSpeechAvail(true);
				setActiveInstrTab('step-1')
			}
		});

		if (!hideSpeakTest && !isSpeechAvail) {
			setActiveInstrTab('step-3')
		}

	}, [domains, isSpeechAvail]);

	let audio = {};
	const isMounted = useRef(true);

	const retryRecording = () => {
		if (Object.keys(audio).length > 0) {
			audio.pause();
		}
		document.getElementById('recordFail').style.display = 'block';
		document.getElementById('beforeStart').style.display = 'block';
		document.getElementById('afterStart').style.display = 'none';
		Loader.hide()
	};

	const handleAction = async () => {
		isMounted.current = true;
		recordButtonRef.current.classList.add("recording-in-progress")

		const recorder = await recordAudio();
		recorder.start();

		const { start, stop, reset } = continuousVisualizer(recorder.getStream(), currentVisual, {
			lineWidth: "thick",
			strokeColor: "#FFFFFF"
		});
		start();

		// document.getElementById('beforeStart').style.display = 'none';
		// document.getElementById('whileRecording').style.display = 'block';
		// document.getElementById('recordFail').style.display = 'none';
		await sleep(6000);
		audio = await recorder.stop();
		reset()
		recordButtonRef.current.classList.remove("recording-in-progress", "fa-microphone", "fa-redo")
		recordButtonRef.current.classList.add("fa-redo")
		stepOneNextButton.current.classList.remove("btn-disabled")

		if (isMounted.current) {
			// document.getElementById('whileRecording').style.display = 'none';
			// document.getElementById('afterStart').style.display = 'block';

			document.getElementById('audioPlayer').src = audio.audioUrl;
			setShowPlayerTag(true)
			// if (isIos()) document.getElementById('audioTestID').src = audio.audioUrl;
			// else audio.play();

			if (!isIos()) {
				audio.play();
			}
		}
		Loader.hide()
	};

	const setSpeechActive = () => {
		toggleMicPermission(true);
		//setSpeechStatus()
		document.getElementById('recordSuccess').style.display = 'block';
		document.getElementById('afterStart').style.display = 'none';
		if (Object.keys(audio).length > 0) {
			audio.pause();
		}
		Loader.hide()
	};

	const startTestTag = () => {
		if (previewMode) {
			localStorage.setItem('previewWebisodeStart', new Date());
			tagEvent({
				event: 'start_course_preview',
				user_id: userId,
				course_id: courseId,
				grant_name: course_name,
				product_id,
				product_name,
				platform: 'web',
			});
		}
		setShowTestInstr(false)
	};

	const instrNavigation = (num) => {
		setActiveInstrTab('step-' + num)
		Loader.hide()
	}

	const agreeCheckboxChange = (event) => {
		setAgreeInstructions(event.target.checked)
	}

	return (

		<>
			<div className={`testInstructionContainer ${showTestInstr ? 'active' : ''}`}>

				{!hideSpeakTest && isSpeechAvail && (
					<>
						<div className={`recordingBox recording-step-1 ${activeInstrTab === 'step-1' && continueAttemptId === 0 ? 'active' : ''}`}>
							<a href='javascript:void(0)' className='setShowTestInstr' onClick={() => setShowTestInstr(false)}>&times;</a>
							<h2 className='recording-title'>Let's test your audio input and output.</h2>
							<div className="container-audio">
								<canvas id="currentVisual" width="75" height="75" />
								<i className="fas fa-microphone" id="recordButton" aria-hidden="true" ref={recordButtonRef} onClick={(e) => {
									handleClickAction(e);
									handleAction()
								}}></i>
							</div>
							<div className="vol-con">
								<span className={`micInfo ${!showPlayerTag ? 'show' : ''}`}>Please ensure MIC volume is high</span>
								<div id="volume-visualizer" className={showPlayerTag ? 'show' : ''}>
									<audio controls id="audioPlayer"></audio>
								</div>
							</div>
							<div className="but">
								<button
									aria-label="Start"
									id="stepOneNextButton"
									ref={stepOneNextButton}
									type="button"
									className="btn btn-lg btn-info go-next btn btn-primary btn-disabled"
									aria-required="true"
									onClick={(e) => {
										handleClickAction(e);
										instrNavigation('2');
									}}
								>Next</button>
							</div>
						</div>
					</>

				)}

				<div className={`recordingBox recording-step-2 ${activeInstrTab === 'step-2' && continueAttemptId === 0 ? 'active' : ''}`}>
					<a href='javascript:void(0)' className='setShowTestInstr' onClick={() => setShowTestInstr(false)}>&times;</a>
					<h2 className='recording-title'>Instructions</h2>
					<ul class="instruction-list">
						<li class="transition-item">Your audio and recording check were successful. Please ensure you do not mute the MIC or adjust any audio/MIC settings till your test is complete.</li>
						<li class="transition-item">Ensure you have a stable and reliable internet connection till your test is complete.</li>
						<li class="transition-item">Please take the test in a quiet room with no background noises.</li>
					</ul>
					<div class="agreeInstructions-cbox transition-item">
						<input type="checkbox" id="agreeInstructions" onChange={agreeCheckboxChange} />
						<label for="agreeInstructions"><p>I have read and understood the instructions.</p></label>
					</div>
					<div className="but">
						<button
							aria-label="Start"
							type="button"
							className={`btn btn-lg btn-info go-next btn btn-primary ${!agreeInstructions ? 'btn-disabled' : ''}`}
							aria-required="true"
							onClick={(e) => {
								handleClickAction(e);
								instrNavigation('3');
							}}
						>Next</button>
					</div>
				</div>


				<div className={`recordingBox recording-step-3 ${activeInstrTab === 'step-3' || continueAttemptId !== 0 ? 'active' : ''}`}>
					<a href='javascript:void(0)' className='setShowTestInstr' onClick={() => setShowTestInstr(false)}>&times;</a>
					<p className='test-infor transition-item'>Test Duration<span>{courseId == '669' ? '30' : sumTimeLimit} minutes</span></p>
					{/* <p className='test-infor'>Questions<span>{totalQuestion}</span></p> */}
					<p className='test-infor transition-item'>Questions<span>{totalQuestion}</span></p>
					<div className="but">
						{!(!!attemptRemaning && !!hideStart) && (
							<button
								aria-label="Start"
								type="button"
								className="btn btn-lg btn-info go-next btn btn-primary"
								aria-required="true"
								onClick={(e) => {
									handleClickAction(e);
									startTestTag();
									startAttempt(courseId, elementId);
								}}
							>Start</button>
						)}
						{!!continueAttemptId && (
							<button
								aria-label="Start"
								type="button"
								className="btn btn-lg btn-info go-next btn btn-primary mar-left"
								aria-required="true"
								onClick={(e) => {
									handleClickAction(e);
									startTestTag();
									fetchAttempt(continueAttemptId);
								}}
							>Continue</button>
						)}
					</div>
				</div>

			</div>

			{/* 
				<Modal
					show={showTestInstr}
					size="lg"
					style={{ minWidth: '300px' }}
					onHide={() => setShowTestInstr(false)}
					backdrop="static"
					keyboard={false}
					id="TestInstruction"
					className={
						(userType === UserTypes.Parent || userType === UserTypes.Junior) &&
							elementType === 'S'
							? 'TestInstruction-w500'
							: ''
					}
				>
					<Modal.Header closeButton>
						<h4 className="modal-title">
							<span>{unitName}</span>{elementName}
						</h4>
					</Modal.Header>
					<Modal.Body>
						<div className="TestInstruction-body">
							{userType === UserTypes.Parent || userType === UserTypes.Junior ? (
								<>
									{elementType === 'S' && (
										<img
											src={Config.ASSETSPATH + 'img/grandtestcore.png'}
											className="grandtestcore-icon"
											alt=""
										/>
									)}
									<div className="instruction_popup_new_style col-lg-12 col-xs-12 ">
										<h6>
											{elementType === 'S'
												? `You can only do this test once. Make sure that you're ready to finish the test in one sitting of 25 minutes. All the best!`
												: `This practice test is the exact same format as the final STEPathon Junior test. This is intended as a practice to understand what kind of questions you will get.`}
										</h6>
									</div>
									{elementType === 'S' ? (
										<div className="col-lg-12 col-xs-12 instruction_popup_new_style text-center">
											<h6 className="new_style_label mar-no">Total Questions</h6>
											<strong className="new_style_value">{totalQuestion}</strong>
										</div>
									) : (
										<div className="col-lg-6 col-xs-12 instruction_popup_new_style">
											<h6>Practice Questions:</h6> <b>{totalQuestion}</b>
										</div>
									)}{' '}
								</>
							) : (
								<>
									{elementType === 'S' && (
										<img
											src={Config.ASSETSPATH + 'img/grandtestcore.png'}
											className="grandtestcore col-lg-6 col-xs-12"
											alt=""
										/>
									)}
									<div className="">
										<div className="instruction_popup_new_style">
											<div className='instruction_popup_ST'>
												<h6>Skills Taught</h6>
												<ul className="popup-icons">{domainList}</ul>
											</div>
										</div>

										<div className=" instruction_popup_new_style">
											<div className='instruction_popup_ST mar-top'>
												<h6>{elementType === 'S' ? 'Questions' : 'Practice Questions'}</h6>
												<b>{totalQuestion}</b>
											</div>
										</div>
									</div>
								</>
							)}
							<div className="click-button">
								{!!reviewAttemptId &&
									localStorage.getItem('active_course_id') !== '428' &&
									Object.keys(reviewAttemptId).length > 0 && unitName !== 'Start' && unitName !== 'Certification' && (
										<div className='btn-popup-review-container'>
											<button
												aria-label="Review"
												type="button"
												className="btn btn-primary btn-popup-review mar-auto"
												onClick={(e) => {
													handleClickAction(e);
													fetchAttempt(reviewAttemptId[0], true);
												}}
											>Review Answer</button>
										</div>
									)}
								<div
									className='click-button-cont'>
									{!(!!attemptRemaning && !!hideStart) && (
										<button
											aria-label="Start"
											className="btn btn-primary btn-popup-start btn-primary-2"
											onClick={(e) => {
												handleClickAction(e);
												startTestTag();
												startAttempt(courseId, elementId);
											}}
											data-dismiss="modal"
										>
											Start
										</button>
									)}
									{!!continueAttemptId && (
										<button
											aria-label="Continue"
											className="btn btn-primary btn-popup-start btn-success-2"
											onClick={(e) => {
												handleClickAction(e);
												startTestTag();
												fetchAttempt(continueAttemptId);
											}}
											data-dismiss="modal"
										>
											Continue
										</button>
									)}
								</div>
							</div>
						</div>
						
					</Modal.Body>
				</Modal>
			*/}
		</>

	);

})

const mapStateToProps = (state) => {
	const { coursedetails: { course_name } = {} } = state.rootReducer.myCourse;
	const { userId } = state.rootReducer.loginDetails;
	const {
		productData: { product_id, product_name } = {},
	} = state.rootReducer.buyCourse;
	return {
		instrDetails: state.rootReducer.myCourse,
		showTestInstr: state.rootReducer.myCourse.showTestInstr,
		showReview: state.rootReducer.testPageDetails.showReview,
		userType: state.rootReducer.loginDetails.userType,
		product_id,
		product_name,
		course_name,
		userId,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchAttempt: (attemptId, review = false) =>
			dispatch(fetchAttempt({ attemptId, review })),
		startAttempt: (courseId, elementId) =>
			dispatch(startAttempt({ courseId, elementId })),
		setSpeechStatus: () => dispatch(setSpeechStatus()),
		toggleMicPermission: (val) => dispatch(toggleMicPermission(val)),
		setShowTestInstr: (val) => dispatch(setShowTestInstr(val)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(TestInstruction);
